<template>
  <div class="now-line" :style="{ transform: 'translateX(calc(480rem * ' + percentThroughDay + ')' }" :class="darkMode ? 'dark' : ''"></div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import OverviewHelper from '@/location/overview/OverviewHelper';
import moment from 'moment-timezone';

@Component({
  props: {
    currentTime: {
      type: String,
      required: true,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
})
export default class NowLine extends Vue {
  get percentThroughDay () {
    return OverviewHelper.timeToPercentThroughDay(moment(this.currentTime));
  }
}
</script>

<style lang="postcss" scoped>
@import 'core/shared/styles';

.now-line {
  position: absolute;
  top: 4.3rem;
  bottom: 0;
  left: 0;
  width: 0.3rem;
  z-index: 1;
  pointer-events: none;
  background: var(--colorSBRedFlat);
}

.now-line.dark {
  background: var(--colorSBRedFlat);
}
</style>
